export const provinceAbbvToName = {
  'AB':'Alberta',
  'BC':'British Columbia',
  'MB':'Manitoba',
  'NB':'New Brunswick',
  'NF':'Newfoundland',
  'NT':'Northwest Territory',
  'NS':'Nova Scotia',
  'NU':'Nunavut',
  'ON':'Ontario',
  'PE':'Prince Edward Island',
  'QC':'Quebec',
  'SK':'Saskatchewan',
  'YT':'Yukon'
};

export const provinceNameToAbbv = {
  'alberta':'AB',
  'british columbia':'BC',
  'manitoba':'MB',
  'new brunswick':'NB',
  'newfoundland':'NF',
  'northwest territory':'NT',
  'nova scotia':'NS',
  'nunavut':'NU',
  'ontario':'ON',
  'prince edward island':'PE',
  'quebec':'QC',
  'saskatchewan':'SK',
  'yukon':'YT'
};
